import styles from "./project-preview.module.css";
import { ProjectTemplate } from "PosterEditor/model/project-template";
import { PosterProject } from "PosterEditor/model/poster-project";
import { useProjectThumbnail } from "./use-project-thumbnail";
import { Size } from "PosterEditor/model/poster-types";
import { filterClasses } from "PosterEditor/utils/filter-classes";
import { ComponentLoadingIndicator } from "admin/shared-components/page-loading-indicator";

interface ProjectPreviewProps {
  template?: ProjectTemplate;
  project?: PosterProject;
  size?: Size;
  showOutline?: boolean;
  allowHoverEffect?: boolean;
  showShadow?: boolean;
  fallbackToMapImage?: boolean;
  className?: string;
}

export const ProjectPreview = ({
  template,
  project,
  size,
  showOutline = false,
  showShadow = true,
  allowHoverEffect = false,
  fallbackToMapImage = true,
  className,
}: ProjectPreviewProps) => {
  const { image, size: resolvedSize } = useProjectThumbnail({
    template: template,
    project: project,
    size: size ?? { width: 140, height: 140 },
    fallbackToMapImage: fallbackToMapImage,
  });

  if (!image) {
    return <ComponentLoadingIndicator />;
  }

  const imageClasses = filterClasses(
    styles.previewImage,
    showOutline ? styles.outline : "",
    allowHoverEffect ? styles.hoverEffect : styles.noHoverEffect,
    showShadow ? "" : styles.noShadow,
    className
  );

  const imageStyle = size
    ? {
        height: resolvedSize.height,
        width: resolvedSize.width,
        objectFit: "contain" as const,
      }
    : undefined;

  return (
    <img
      className={imageClasses}
      style={imageStyle}
      src={image}
      alt={template?.name ?? project?.name ?? "Project Preview"}
    />
  );
};
